import LandAtlas from './LandAtlas'

export default LandAtlas
